import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ApiCollectionWorkspaceApi = createApi({
	reducerPath: "ApiCollectionWorkspaceApi",
	tagTypes: ["RequestDetails"],
	baseQuery: fetchBaseQuery({
		baseUrl: import.meta.env.VITE_API_BASE_URL + "/workspace-mgmt",
		headers: {
			"Content-Type": "application/json",
			"x-api-key": import.meta.env.VITE_WORKSPACE_API_KEY,
			accessToken: localStorage.getItem("accessToken") || "",
		},
	}),
	endpoints: (builder) => ({
		getProjectsByTeamId: builder.query({
			query: (id) => `/workspace/team/${id}`,
		}),
	}),
});

export const { useGetProjectsByTeamIdQuery } = ApiCollectionWorkspaceApi;
